const ErrorIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666504 13H15.3332L7.99984 0.333374L0.666504 13ZM8.6665 11H7.33317V9.66671H8.6665V11ZM8.6665 8.33337H7.33317V5.66671H8.6665V8.33337Z"
        fill="#E45858"
      />
    </svg>
  );
};

export default ErrorIcon;
